<template>
  <div
    class="relative flex gap-2 cursor-pointer font-sans"
    tabindex="0"
    @click="
      () => {
        isOpen = !isOpen
      }
    "
    @focusout="
        (event) => {
          if (event.relatedTarget){
            const relatedTarget = event.relatedTarget as HTMLBaseElement
            const target = event.target as HTMLBaseElement
            if (relatedTarget.contains(target) === false && target.contains(relatedTarget) === false ){
              isOpen = false
            }
          } else if (event.relatedTarget === null) {
            isOpen = false
          }
        }
        "
  >
    <div class="font-light">{{ $t('jobPlatform.listJobSortHeader') }}</div>
    <div class="text-blue font-semibold">
      {{ sortByOptions[activeSortLabelIndex] }}
    </div>
    <div
      v-if="isOpen"
      class="flex flex-col absolute font-sans top-8 right-0 p-5 gap-4 bg-white min-w-full border border-gray-300 rounded-xl text-lg z-10 shadow-md"
      @click.stop=""
    >
      <div
        v-for="(sortLabel, index) in sortByOptions"
        class="flex text-lg select-none"
        :class="
          sortByOptions[activeSortLabelIndex] === sortLabel
            ? ['text-blue']
            : ['text-gray-500']
        "
        @click="
          () => {
            setActiveSort(index)
            isOpen = false
          }
        "
      >
        {{ sortLabel }}
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
defineProps<{ sortByOptions: string[] }>()

const emit = defineEmits<{
  (e: 'setChange', value: number): void
}>()

const isOpen = ref(false)
const activeSortLabelIndex = ref(0)

const setActiveSort = (activeIndex: number) => {
  activeSortLabelIndex.value = activeIndex

  emit('setChange', activeSortLabelIndex.value)
}
</script>
